if (self !== top) {
  var body = document.body;
  body.classList.add("antiClickjack");
  top.location = self.location;
}
